import { useTheme } from '@mui/material/styles';

function useIsDarkMode() {
	const theme = useTheme();
	return theme.palette.mode === 'dark';
}

export default useIsDarkMode;
